import * as angular from 'angular';
import * as _ from 'lodash';

import { IOnlineComputationService, ITranslatedLoggerService } from '../../services';
import { tasksChanged } from '../../common/';
import { ComponentDefinition, IGroupSchedulingViewModelRow } from '../../models';

class ModelJobsTreeController implements angular.IComponentController {
    displayedGroups: IGroupSchedulingViewModelRow[];
    groups: any[];
    isEditMode: boolean = false;
    isElapsedDisplayed: boolean;
    isLoading: boolean;
    isOffline: boolean;
    refresh: () => angular.IPromise<void>;
    selectedGroup: any;

    static $inject = [
        '$rootScope',
        '$element',
        '$translate',
        '$timeout',
        'onlineComputationService',
        'translatedLoggerService'
    ];
    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _$element: angular.IAugmentedJQuery,
        private _$translate: angular.translate.ITranslateService,
        private _$timeout: angular.ITimeoutService,
        private _onlineComputationService: IOnlineComputationService,
        private _loggerService: ITranslatedLoggerService
    ) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['displayedGroups']) {
            this.updateRows();
        }
    }

    select(group, $event) {
        this.selectedGroup = group;
        $event.preventDefault();
    }

    stop(group) {
        this.isLoading = true;
        this._onlineComputationService
            .stop({
                guid: group.jobGuid,
                groupGuid: group.guid
            })
            .then(data => {
                this.isLoading = false;
                if (data && data.length) {
                    const message = this._$translate.instant('_count_ dates have been canceled.', { count: data.length });
                    this._loggerService.logSuccess(message);
                } else {
                    this._loggerService.logSuccess('Online computation stopped.');
                }
                this._$rootScope.$broadcast(tasksChanged);
                return this.refresh();
            })
            .catch(() => this.isLoading = false);
    }

    private updateRows() {
        this._$timeout(() => {
            try {
                // Far from ideal, this relies on the DOM structure. Leaving as is, as the migration to React is around the corner
                this._$element.parent().scrollTop(0);
            } catch (e) {
                console.error(e);
            }
        });
    }
}

export const wtModelJobsTree: ComponentDefinition = {
    componentId: 'wtModelJobsTree',
    controller: ModelJobsTreeController,
    template: require('./modelJobsTree.component.html'),
    controllerAs: 'vm',
    bindings: {
        displayedGroups: '<',
        selectedGroup: '=',
        isOffline: '<',
        isElapsedDisplayed: '<',
        refresh: '&'
    }
};